import { Badge } from '@@/Badge';

export function SystemBadge() {
  return <Badge type="success">system</Badge>;
}
